export const TransferType = {
    Internal: 'internal',
    External: 'external',
    Withdraw: 'withdraw',
    Deposit: 'deposit',
};
